'use client';

import { createContext, use } from 'react';
import { useReadLocalStorage } from 'usehooks-ts';

const AdminContext = createContext(false);

export function AdminProvider({ children }: { children: React.ReactNode }) {
  const isAdmin = !!useReadLocalStorage<boolean>('admin', {
    initializeWithValue: false,
  });

  return <AdminContext value={isAdmin}>{children}</AdminContext>;
}

export function useAdmin() {
  return use(AdminContext);
}
